import React from 'react';
import { connect } from 'react-redux';
import AsyncSelect from "react-select/async";
import axios from 'axios';
import ErrorValidation from '../../../services/ErrorValidation';
import Ax from '../../../components/hoc/Ax';
import ReactSelectStyle from '../../../components/ui/ReactSelectStyle';
import { IAM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import api from '../../../services/api';

class InputWalletSearch extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            selectedWallet: null,
            timer: false,
            defaultOptions: [],
        };
        this.cancelToken = null;
        this.apiTimeout = null;
        this.wallet_list_url = IAM_API_BASE_URL_2 + '/wallets';
    }
    
    initParams = (props) => {
        this.setState({
            params: {}
        }, () => {
            if(this.props.loadDefaultOptions == true && !this.props.linkedWallet) {
                this.getDefaultOptions();
            }
            if(this.props.loadDefaultOptions == true && this.props.linkedWallet && this.props.linkedWallet.length > 0) {
                this.setState({
                    defaultOptions: this.displayStringSearch(this.props.linkedWallet)
                });
            }
        });
    }
    
    componentDidMount() {
        this.initParams(this.props);
    }

    onInputChange = (selectedOption) => {
        this.props.changeEvent(selectedOption);
    }
    
    displayStringSearch = (wallets) => {
        return wallets.map(wallet => {
            return {
                label: wallet.wallet_name + ' (' + wallet.wallet_type_name + ') - ' + wallet.status_display,
                value: wallet.id,
                wallet: wallet
            };
        });
    };
    
    loadingOptions = (inputText, callback) => {
        if(inputText.length > 2) {
            clearTimeout(this.apiTimeout)
            if (this.cancelToken) {
                this.cancelToken.cancel("Operation canceled due to new request.")
            }
            this.cancelToken = axios.CancelToken.source();

            let params = {
                search_by_text: inputText, 
                per_page: 50,
                transaction_datetime: this.props.transaction_date ? this.props.transaction_date : null,
            };
            
            this.apiTimeout = setTimeout(() => {this.getLoadingOptions(params, callback)}, 1000);
        }
    }

    getLoadingOptions = (params, callback) => {
        api.server2Api({
            method: 'GET',
            headers: { 'Authorization': 'Bearer ' + this.props.access_token },
            params: params,
            url: this.wallet_list_url,
            cancelToken: this.cancelToken.token
        })
        .then((response) => {
            callback(this.displayStringSearch(response.data.data))
        }).catch((err) => {
            if (axios.isCancel(err)) {
                // Request cancelled
            } else {
                ErrorValidation.apiErrorHandle(err, 'Unable to Get Wallet Data.');
            }
        });
    }

    getDefaultOptions = () => {
        this.setState({defaultOptions: []});
        
        let params = {
            per_page: 25
        };
        
        api.server2Api({
            method: 'GET',
            headers: { 'Authorization': 'Bearer ' + this.props.access_token },
            params: params,
            url: this.wallet_list_url
        })
        .then((response) => {
            this.setState({
                defaultOptions: this.displayStringSearch(response.data.data)
            });
        }).catch((err) => {
            if (axios.isCancel(err)) {
                // Request cancelled
            } else {
                ErrorValidation.apiErrorHandle(err, 'Unable to Get Wallet Data.');
            }
        });
    }
    
    render() {
        return (
            <Ax>
                <AsyncSelect
                    styles={ReactSelectStyle(this.props)}
                    menuPlacement={this.props.menuPlacement ? this.props.menuPlacement : "bottom"}
                    placeholder={this.props.placeholder || "Search Wallet by Name"}
                    loadingMessage={(input) => {
                        if(input.inputValue && input.inputValue.length <= 2) {
                            return 'Please enter 3 or more characters';
                        } else {
                            return 'Searching...';
                        }
                    }}
                    noOptionsMessage={(input) => {
                        if(input.inputValue && input.inputValue.length == 0) {
                            return 'Please enter 3 or more characters';
                        } else {
                            return 'No Wallet found';
                        }
                    }}
                    minimumInput={3}
                    complete={true}
                    onChange={this.onInputChange}
                    isClearable={true}
                    loadOptions={this.loadingOptions}
                    value={this.props.value}
                    isMulti={this.props.isMulti || false}
                    required={this.props.required || false}
                    isDisabled={this.props.disabled || false}
                    defaultOptions={this.props.loadDefaultOptions == true ? this.state.defaultOptions : null}
                />
                <input
                    name=''
                    tabIndex={-1}
                    required={this.props.required || false}
                    value={this.props.isMulti ? (this.props.value && this.props.value.length > 0 ? this.props.value.map(v => v.label).join(', ') : '') : (this.props.value ? this.props.value.label : '')}
                    onChange={() => {}}
                    style={{
                        opacity: 0,
                        width: 0,
                        height: 0,
                        padding: 0,
                        margin: 0,
                        display: 'table'
                    }}
                />        
            </Ax>
        );
    }
}

const mapStateToProps = state => {
    return {
        access_token: state.auth.access_token
    };
};

export default connect(mapStateToProps)(InputWalletSearch);